import React from 'react';

interface Props {
	size: number;
}

export const TimeIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>time</title>
		<path d='M12 19.79a6.95 6.95 0 117-6.95 7 7 0 01-7 6.95zm0-13.06a6.12 6.12 0 106.12 6.11A6.12 6.12 0 0012 6.73z' />
		<path d='M14.86 13.26h-3.27V8.74a.41.41 0 11.82 0v3.69h2.45a.41.41 0 01.41.41.41.41 0 01-.41.42z' />
		<path d='M12 23.57a10.65 10.65 0 110-21.29.41.41 0 01.41.41.41.41 0 01-.41.42 9.82 9.82 0 106.89 2.82.42.42 0 01.59-.59A10.65 10.65 0 0112 23.57z' />
		<path d='M11 5a.43.43 0 01-.28-.11.41.41 0 010-.58l1.46-1.65-1.65-1.51a.42.42 0 01.56-.62l2.27 2-2 2.27A.43.43 0 0111 5z' />
	</svg>
);
